import { TrackWithCb } from '@rmc/webcx-web-libs';

export type TrackEventPropsType = {
	version: string;
	projectKey: string;
	campaignId: string;
	correlationId?: string | null;
	contentId: string;
	ratAccountId: string;
	ratServiceType: string;
	ratServiceId: string;
	isMobile: boolean;
	sessionId: string;
	domainScopedSessionId: string;
	userId: string;
	clientId: string;
	trackCb: () => void;
	message?: string;
	ratApiAccountSrc?: string;
	isRatCoreEventsOnly?: boolean;
	isPreview?: boolean;
};

export function TrackAppDisplay(rest: TrackEventPropsType) {
	return TrackWithCb({
		screen: 'APP',
		action: 'DISPLAY',
		...rest,
	});
}
